(function () {
  'use strict';

  angular
      .module('tfc.News')
      .controller('NewsCtrl', NewsCtrl);

  // @ngInject
  function NewsCtrl($injector, $state, Nav, LookAndFeel, AnalyticsHelper, LookAndFeelType) {
    var vm = this;

    vm.sendViewChangeEvent = function () {
      AnalyticsHelper.sendViewChangeEvent(LookAndFeelType.Analytics);
      $state.go(vm.firstMenuItem);
    };


    // TODO - Need to solve this by separating menu items
    //setting lookAndFeel to Analytics so that only analytics menu items would be seen on UI
    LookAndFeel.setToAnalytics();
    var analyticsFirstMenuItem = _.find(Nav.mainMenu(), function (menuItem) {
      return $injector.invoke(menuItem.canAccess);
    });
    vm.firstMenuItem = analyticsFirstMenuItem && analyticsFirstMenuItem.state.name();

    //setting lookAndFeel back to Brand Metrics so that only brand metrics menu items would be seen on UI
    LookAndFeel.setToBrandMetrics();

  }
})();
